import { ModalWindowBodyProps } from "./components/modal-window-body";
import { ModalWindowContainerProps } from "./components/modal-window-container";
import { ModalWindowFooterProps } from "./components/modal-window-footer";
import { ModalWindowHeaderProps } from "./components/modal-window-header";

export enum ModalWindowSizeEnum {
  Small = 'sm',
  Medium = 'md',
}

export interface ModalWindowProps
  extends ModalWindowContainerProps,
    Omit<ModalWindowHeaderProps, 'children'>,
    ModalWindowFooterProps,
    ModalWindowBodyProps {
  title?: string
}